// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r2dQ5","question":"styles_question__10xI7","inputVisibleButton":"styles_inputVisibleButton__1-eIi","note":"styles_note__2Kyl9"};